/* istanbul ignore file */
import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import { LEAD_GRADE } from 'domain/sales/lead/shared/leadService';
import { Dropdown } from 'framework/form';
import { NULL_AS_STRING } from 'framework/utils';

const LeadGradeFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  const emptyGradeEntry = { value: NULL_AS_STRING, label: 'Without Grade' };
  const baseEntries = Object.entries(LEAD_GRADE).map(entry => {
    const [value, gradeObject] = entry;
    const { name, shorthand } = gradeObject;

    return {
      value,
      label: `${shorthand} (${name})`,
    };
  });
  const resultOptions = [emptyGradeEntry, ...baseEntries];

  return (
    <DropDownFilter {...props}>
      <Dropdown placeholder="Choose lead grade" options={resultOptions} label="Lead grade" {...props} />
    </DropDownFilter>
  );
};

export default LeadGradeFilter;
